// extracted by mini-css-extract-plugin
export default {"btnpwd":"_6fba9fb568"};